import React from 'react';
import { Link } from 'react-router-dom';
import siteImages from '../../config/images';
import { useApp } from '../../context/AppContext';
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaTiktok
} from 'react-icons/fa';

const Footer = () => {
  const { settings, currentYear } = useApp();

  return (
    <footer className="relative">
      {/* Main Footer Content with background image */}
      <div className="relative" style={{
        backgroundImage: `url("${siteImages.footerBackground}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
        {/* Lighter overlay for better visibility */}
        <div className="absolute inset-0 bg-navy/60 backdrop-blur-sm" />

        {/* Content */}
        <div className="relative z-10">
          <div className="container-custom py-16">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              {/* Company Info - Left */}
              <div>
                <div className="mb-6">
                  <Link to="/" className="inline-block hover:opacity-80 transition-opacity">
                    <img src="/logo.svg" alt="PRO-BYTY.cz" className="h-10 w-auto brightness-0 invert" />
                  </Link>
                </div>
                <p className="text-gray-200 mb-6">
                  {settings.site_description || 'Jsme tým profesionálů, který se specializuje na nákup, rekonstrukci a prodej bytů v Praze. Vytváříme domovy, které přinášejí radost a komfort svým obyvatelům.'}
                </p>

                {/* Social Icons */}
                <div className="flex gap-4">
                  {settings.facebook && (
                    <a
                      href={settings.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-gold hover:text-white transition-all transform hover:scale-110"
                      aria-label="Facebook"
                    >
                      <FaFacebook size={20} />
                    </a>
                  )}
                  {settings.instagram && (
                    <a
                      href={settings.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-gold hover:text-white transition-all transform hover:scale-110"
                      aria-label="Instagram"
                    >
                      <FaInstagram size={20} />
                    </a>
                  )}
                  {settings.linkedin && (
                    <a
                      href={settings.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-gold hover:text-white transition-all transform hover:scale-110"
                      aria-label="LinkedIn"
                    >
                      <FaLinkedin size={20} />
                    </a>
                  )}
                  {settings.youtube && (
                    <a
                      href={settings.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-gold hover:text-white transition-all transform hover:scale-110"
                      aria-label="YouTube"
                    >
                      <FaYoutube size={20} />
                    </a>
                  )}
                  {settings.tiktok && (
                    <a
                      href={settings.tiktok}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-gold hover:text-white transition-all transform hover:scale-110"
                      aria-label="TikTok"
                    >
                      <FaTiktok size={20} />
                    </a>
                  )}
                </div>
              </div>

              {/* Services - Center */}
              <div className="md:pl-12">
                <h3 className="text-white font-heading text-xl mb-6">Naše služby</h3>
                <ul className="space-y-3">
                  <li>
                    <Link to="/koupit-byt" className="text-gray-200 hover:text-gold transition-colors">
                      Chci koupit byt
                    </Link>
                  </li>
                  <li>
                    <Link to="/prodat-byt" className="text-gray-200 hover:text-gold transition-colors">
                      Chci prodat byt
                    </Link>
                  </li>
                  <li>
                    <Link to="/spoluprace" className="text-gray-200 hover:text-gold transition-colors">
                      Chci spolupracovat
                    </Link>
                  </li>
                  <li>
                    <Link to="/rychly-vykup" className="text-gray-200 hover:text-gold transition-colors">
                      Rychlý výkup
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Contact - Right */}
              <div className="md:pl-12">
                <h3 className="text-white font-heading text-xl mb-6">Kontakt a údaje</h3>
                <div className="space-y-3 text-gray-200">
                  <p>{settings.contact_address || 'Václavské náměstí 1, Praha 1'}</p>
                  <p>
                    <a
                      href={`tel:${settings.contact_phone?.replace(/\s/g, '')}`}
                      className="hover:text-gold transition-colors"
                      aria-label={`Zavolat na ${settings.contact_phone || '+420 777 123 456'}`}
                    >
                      {settings.contact_phone || '+420 777 123 456'}
                    </a>
                  </p>
                  <p>
                    <a
                      href={`mailto:${settings.contact_email}`}
                      className="hover:text-gold transition-colors"
                      aria-label={`Napsat email na ${settings.contact_email || 'info@pro-byty.cz'}`}
                    >
                      {settings.contact_email || 'info@pro-byty.cz'}
                    </a>
                  </p>
                  {settings.company_ico && (
                    <p className="pt-2 border-t border-white/10">
                      IČO: {settings.company_ico}
                    </p>
                  )}
                  {settings.registry_entry && (
                    <p className="text-sm">
                      {settings.registry_entry}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar - Darker navy background */}
      <div className="bg-[#0f1e2e]">
        <div className="container-custom py-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            {/* Left side - Copyright and legal links */}
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <p className="text-gray-400 text-sm">
                © {currentYear} {settings.site_title || 'PRO-BYTY.cz'}. Všechna práva vyhrazena.
              </p>
              <div className="flex gap-4">
                <Link to="/gdpr" className="text-gray-400 text-sm hover:text-gold transition-colors">
                  GDPR
                </Link>
                <Link to="/cookies" className="text-gray-400 text-sm hover:text-gold transition-colors">
                  Cookies
                </Link>
              </div>
            </div>

            {/* Right side - Stebex logo (HARDCODED - nepřepisovat) */}
            <a
              href="https://stebex.cz/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col sm:flex-row items-center gap-2 mt-4 md:mt-0 hover:opacity-80 transition-opacity"
            >
              <span className="text-gray-400 text-sm">Webové stránky a administrační systém od</span>
              <img
                src="https://imagedelivery.net/TtlFh2d-eb4ze5NHgekWCg/62abbdec-cbc3-45a1-6701-8a6b4ed2b800/public"
                alt="Stebex"
                decoding="async"
                className="h-6"
                width="100"
                height="24"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;